<div class="duna-event-form-page">
  <app-dynamic-form
    class="duna-event-form-survey"
    [dynamicInput]="dynamicInput"
  ></app-dynamic-form>
</div>
